import { render, staticRenderFns } from "./CbsLayoutVertical.vue?vue&type=template&id=1cf60adc"
import script from "./CbsLayoutVertical.vue?vue&type=script&lang=js"
export * from "./CbsLayoutVertical.vue?vue&type=script&lang=js"
import style0 from "./CbsLayoutVertical.vue?vue&type=style&index=0&id=1cf60adc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports